import { makeHttpRequest } from "@/shared";

export const getTranslations = async (locale = "ru") => {
    const response = await makeHttpRequest({
        url: `translations?lang=${locale}`,
        method: "get",
    });

    return response?.data;
};
